import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle,
} from '@material-ui/core';
import { t } from 'src/lib/language';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { DIALOGS } from 'src/models/DialogModel';
import { closeDialog } from 'src/redux/actions/dialogActions';
import { deleteContactGroupAction } from 'src/redux/actions/contactGroupActions';

const DeleteGroupDialog = () => {
  const dispatch = useAppDispatch();

  const { opened, payload } =
    useSelector((state: Store) => {
      if (state.dialog[DIALOGS.deleteGroup]) {
        return state.dialog[DIALOGS.deleteGroup];
      }
      return { opened: false, payload: null };
    });

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const handleCancel = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteGroup }));
  };

  const handleOk = () => {
    dispatch(closeDialog({ dialog: DIALOGS.deleteGroup }));
    dispatch(deleteContactGroupAction(payload));
  };

  return (
    <Dialog
      maxWidth="xs"
      aria-labelledby="deleting-group"
      open={opened}>
      <DialogTitle id="deleting-group">{t(lang, 'menus.deleting_group')}</DialogTitle>
      <DialogContent dividers>
        {t(lang, 'menus.deleting_group_confirmation')}
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={handleCancel} color="primary">
          {t(lang, 'misc.no')}
        </Button>
        <Button onClick={handleOk} color="primary">
          {t(lang, 'misc.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteGroupDialog;
